// utils/parseHtmlTextToJson.ts

import { stripHTML } from "./stripHTML";

/**
 * Làm sạch thẻ HTML và parse chuỗi JSON (Object hoặc Array).
 * Tự động unescape các ký tự HTML entities và chuẩn hóa format JSON nếu cần.
 */
export function parseHtmlJson<T = any>(htmlText?: string): T | null {
  if (!htmlText || typeof htmlText !== "string") return null;

  try {
    // 1. Remove scripts, styles and strip HTML tags
    let text = htmlText
      .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
      .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, "");

    text = stripHTML(text);

    // 2. Unescape common HTML entities
    text = text
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, "&")
      .replace(/&nbsp;/g, " ")
      .trim();

    if (!text) return null;

    // 3. Thử parse trực tiếp
    try {
      return JSON.parse(text) as T;
    } catch {
      // 4. Chuẩn hóa JS-object → JSON (quote keys, remove trailing commas) nếu có
      const normalizedJson = text
        .replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":')
        .replace(/,\s*}/g, "}")
        .replace(/,\s*]/g, "]");

      return JSON.parse(normalizedJson) as T;
    }
  } catch (error) {
    console.error("parseHtmlJson failed:", error);
    return null;
  }
}

/**
 * Parse chuỗi HTML chứa JSON dạng mảng (Array).
 * Luôn trả về mảng T[] an toàn.
 */
export function parseHtmlTextToJson<T = any>(htmlText?: string): T[] {
  if (!htmlText || typeof htmlText !== "string") return [];

  const parsed = parseHtmlJson<T | T[]>(htmlText);
  if (Array.isArray(parsed)) return parsed as T[];
  if (parsed && typeof parsed === "object") return [parsed as T];
  return [];
}

export default parseHtmlTextToJson;
